export enum AttachmentType {
    Default,
    Photo,
    Document,
    Other
}